import { render, staticRenderFns } from "./settingRefund.vue?vue&type=template&id=3c2875d2&scoped=true"
import script from "./settingRefund.vue?vue&type=script&lang=js"
export * from "./settingRefund.vue?vue&type=script&lang=js"
import style0 from "./settingRefund.vue?vue&type=style&index=0&id=3c2875d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2875d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2875d2')) {
      api.createRecord('3c2875d2', component.options)
    } else {
      api.reload('3c2875d2', component.options)
    }
    module.hot.accept("./settingRefund.vue?vue&type=template&id=3c2875d2&scoped=true", function () {
      api.rerender('3c2875d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/settingRefund.vue"
export default component.exports